var map = {
	"./icons.svg": "./vendor/ruby/3.2.0/bundler/gems/decidim-c8535dac229b/decidim-system/app/packs/images/icons.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./vendor/ruby/3.2.0/bundler/gems/decidim-c8535dac229b/decidim-system/app/packs/images sync recursive ^\\.\\/.*$";